/* eslint-disable @typescript-eslint/no-var-requires */
import * as React from "react";
import Headline from "../../components/Headline";
import { MainLayout } from "../../components/Layout";
import SmartButton from "../../components/SmartButton";
import "./styles.scss";
import { oneLink } from "../../shared/oneLink";
import AnchorButton from "../../components/AnchorButton";

const check = require("../../assets/icon/check.svg").default;

interface TransitionCancelProps {
    onTransitionCancel: () => Promise<void>;
    isLoading: boolean;
}

const TransitionCancel = (props: TransitionCancelProps) => {
    return (
        <MainLayout>
            <Headline>
                クレジットカード決済への
                <br />
                移行をキャンセル
            </Headline>
            <aside className="cation-wrapper">
                <div className="cation">
                    <h4>ご確認ください</h4>
                    <p>
                        すでにAppleサブスクリプションをご解約されている場合、お相手とのやりとりが、次回更新日で停止され、以下の機能が利用できなくなります。
                    </p>
                </div>
            </aside>

            <section>
                <h3 className="list-header">停止される機能</h3>
                <ul className="stop-feature">
                    <li>
                        <img
                            src={check}
                            alt="list marker"
                            width="30"
                            height="30"
                        />
                        お相手へのメッセージ送信
                    </li>
                    <li>
                        <img
                            src={check}
                            alt="list marker"
                            width="30"
                            height="30"
                        />
                        お相手からのメッセージ閲覧
                    </li>
                    <li>
                        <img
                            src={check}
                            alt="list marker"
                            width="30"
                            height="30"
                        />
                        コネクトシップ会員とのコンタクト
                    </li>
                    <li>
                        <img
                            src={check}
                            alt="list marker"
                            width="30"
                            height="30"
                        />
                        コネクトシップ会員との交際
                    </li>
                    <li>
                        <img
                            src={check}
                            alt="list marker"
                            width="30"
                            height="30"
                        />
                        コンシェルジュへの相談
                    </li>
                </ul>
                <div className="user-action-area">
                    <h3>キャンセルしますか？</h3>
                    <SmartButton
                        onClick={props.onTransitionCancel}
                        isLoading={props.isLoading}
                    >
                        キャンセルする
                    </SmartButton>
                    <AnchorButton href={oneLink()} color="secondary">
                        アプリでやりとりを確認
                    </AnchorButton>
                </div>
            </section>
        </MainLayout>
    );
};

export default TransitionCancel;
